const isContainLocation = (location, polygon) => {
  return window.google.maps.geometry.poly.containsLocation(
    location,
    new window.google.maps.Polygon({ paths: polygon })
  );
};

export default isContainLocation;
